import { clearFieldsEmpty_adjunto, receiveCheck, receiveFecha, receiveFechaFormat2, sendCheck } from "../../../../../../../../adapters/helpers"

const InscripcionesAdapters = {

    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idinscripcion || '',
                    estado: item.estado || '',
                    fecha: receiveFechaFormat2(receiveFecha(item.fecha)),
                    importe: item.importe || '',
                    label__importe: item.importe ? (item.importe + ' €') : '',
                    nombre_completo: item.persona?.nombre_completo || '',
                    habilitarcertificado: item.habilitarcertificado || false,
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data



                const items = dataTemp?.data?.map((item: any) => (this.schema(item)))
                // const items = this.schema(dataTemp)

                return {
                    data: {
                        total: dataTemp?.total,
                        per_page: dataTemp?.per_page,
                        current_page: dataTemp?.current_page,
                        items
                    },
                    status: data?.status
                }
            }
        },
    },

    GET_EXCEL: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    headers: item.headers
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}
                
                const data = {
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    POST: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)


                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idpersona: item.idpersona || '',
                    idevento: item.idevento || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idcondicionpago: item.idcondicionpago || '',
                    ideventotarifa: item.ideventotarifa || '',
                    observaciones: item.observaciones || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)


                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    ideventotarifa: item.id || '',
                    idevento: item.idevento || '',
                    idserviciolinea: item.idserviciolinea || '',
                    tarifa: item.tarifa || '',
                    tarifaaplicadaa: item.tarifaaplicadaa || '',
                    precio: item.precio || '',
                    idiva: item.idiva || '',
                    importeiva: item.importeiva || '',
                    importe: item.importe || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    DELETE: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)


                return {
                    data: items,
                    status: data?.status
                }
            }
        },
    },

    POST_ENVIAR_EMAILS_MASIVOS: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    comunicacion: item.comunicacion || '',
                    asunto: item.asunto || '',
                    tipo: item.tipo || '',
                    idtiponotificacion: item.idtiponotificacion || '',
                    idweb: item.idweb || '',
                    remitentenombre: item.remitentenombre || '',
                    remitenteemail: item.remitenteemail || '',
                    filtros: item.filtros || {},
                    lista_ids: item.lista_ids || {},
                    lista_exclusion: item.lista_exclusion || {},
                    adjunto: item.adjunto || '',
                }

                return clearFieldsEmpty_adjunto(data)

            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH_ACTUALIZAR_CERTIFICADO: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)


                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    lista: item.lista || {},
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },
}

const InscripcionAdapters = {

    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idinscripcion || '',
                    idpersona: item.idpersona || '',
                    abona: item.abona || '',
                    idevento: item.idevento || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idcondicionpago: item.condicion_pago?.idcondicionpago || '',
                    ideventotarifa: item.ideventotarifa || '',
                    observaciones: item.observaciones || '',
                    facturas_lineas: item.facturas_lineas || [],
                    nombre_completo: item.persona?.nombre_completo || '',
                    estado: item.estado || '',
                    facturar: receiveCheck(item.facturar, 'facturar'),
                    comunicar: receiveCheck(item.comunicar, 'comunicar'),
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                // const items = dataTemp?.map((item: any) => (this.schema(item)))
                const items = this.schema(dataTemp)                

                return {
                    data: {
                        ...items
                    },
                    status: data?.status
                }
            }
        },
    },

    POST: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)


                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idpersona: item.idpersona || '',
                    idevento: item.idevento || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idcondicionpago: item.idcondicionpago || '',
                    ideventotarifa: item.ideventotarifa || '',
                    observaciones: item.observaciones || '',
                    facturar: sendCheck(item.facturar),
                    comunicar: sendCheck(item.comunicar),
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },
    
    PATCH: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)


                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idpersona: item.idpersona || '',
                    idevento: item.idevento || '',
                    idpersonaentidad: item.idpersonaentidad || '',
                    idcondicionpago: item.idcondicionpago || '',
                    ideventotarifa: item.ideventotarifa || '',
                    observaciones: item.observaciones || '',
                    estado: item.estado || '',
                    facturar: sendCheck(item.facturar),
                    comunicar: sendCheck(item.comunicar),
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },
}

export {
    InscripcionesAdapters,
    InscripcionAdapters,
}